import { render, staticRenderFns } from "./inviteRule.vue?vue&type=template&id=4d225ab6&scoped=true&"
import script from "./inviteRule.vue?vue&type=script&lang=js&"
export * from "./inviteRule.vue?vue&type=script&lang=js&"
import style0 from "./inviteRule.vue?vue&type=style&index=0&id=4d225ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d225ab6",
  null
  
)

export default component.exports